import * as React from 'react';

import { IRegularInfrastructureData, TRegularInfrastructureType } from '../../../types/map';
import { getInfrastructureByYear } from '../helpers';

export const useFutureTypes = (
  regularInfrastructureMapByYearRef: React.MutableRefObject<Map<number, IRegularInfrastructureData>>,
): [TRegularInfrastructureType[], (year: number) => void] => {
  const [futureTypes, setFutureTypesState] = React.useState<TRegularInfrastructureType[]>([]);

  const setFutureTypes = React.useCallback(
    (selectedYear: number | null) => {
      if (!selectedYear) {
        setFutureTypesState([]);

        return;
      }

      const { futureTypes } = getInfrastructureByYear(regularInfrastructureMapByYearRef.current, selectedYear);

      setFutureTypesState(futureTypes);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [regularInfrastructureMapByYearRef, regularInfrastructureMapByYearRef.current],
  );

  return [futureTypes, setFutureTypes];
};
